import React from 'react'
import { Controller } from 'react-hook-form'
import Select from 'react-select';

const CustomSelect = ({
    name, 
    control,
    options,
    placeholder,
    isMulti = false,
    isSearchable = false,
    getOptionLabel = (option) => option.label,
    getOptionValue = (option) => option.value,
    rules 
}) => {
    const transformedOptions = options.map((option) => ({
        label: getOptionLabel(option),
        value: getOptionValue(option),
        ...option,
    }));

    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({field, fieldState}) => {
                return (
                    <>
                        <Select 
                            {...field}
                            options={transformedOptions}
                            placeholder={placeholder}
                            isMulti={isMulti}
                            isSearchable={isSearchable}
                            className={`react-select ${fieldState.invalid ? 'is-invalid' : ''}`}
                        />
                        {fieldState.invalid && (
                            <div className="invalid-feedback">{fieldState.error?.message}</div>
                        )}
                    </>
                )
            }}
        />
    );
}


export default CustomSelect